export const SET_TOAST = 'SET_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';

export const setToast = message => {
  return { type: SET_TOAST, message };
};

export const clearToast = () => {
  return { type: CLEAR_TOAST };
};
